import React from 'react';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';
import ListItemPerson from '../AbstractComboBox/ListItemPerson/ListItemPerson';
import { SuggestComboBox, SuggestComboBoxProps } from '../AbstractComboBox/SuggestComboBox';
import getUserTopResults from './getUserTopResults';

export default function UserSelectComboBox(props: SuggestComboBoxProps<TopUserResult>) {
  return (
    <SuggestComboBox {...props} responseMapper={getUserTopResults}>
      {item => <ListItemPerson user={item} withEmail />}
    </SuggestComboBox>
  );
}
